<template>
    <div>
        <div v-highlight language="php">
            <pre class="language-javascript shadow-none w-full">
<code>
{{formated()}}
</code>
            </pre>
        </div>

        <textarea style="width: 22px; opacity: 0; position: absolute;z-index: -99;" :id="popupData.campaign_identifier">{{formated()}}</textarea>

        <div class="flex justify-end">
            <vs-button class="mr-4" @click="copy(popupData.campaign_identifier)" color="primary" type="filled">{{$t('tooltip.Copy')}}</vs-button>
            <vs-button ref="btnDownload" @click.prevent="download(formated(), `${popupData.campaign_name}.php`, 'text/plain')" color="primary" type="filled">{{$t('global.Download')}}</vs-button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        popupData: {
            type: Object,
            require: true
        },
        popupButton: {
            type: String
        },
        popupType: {
            type: String
        }
    },

    data() {
        return {}
    },

    methods: {
        formated() {
            let code = ''

            const popupData = this.popupData

            code += `<?php\n`
            code += `$campaign_identifier = '${popupData.campaign_identifier}';\n`
            code += `$affiliate_hash = '${popupData.affiliate_hash}';\n`
            code += `$landing_name = '${popupData.landing_name}';\n`
            code += `$language = '${popupData.language}';\n`
            code += `$base = '/';\n`
            code += `$thankyou = 'thankyou.php';\n`
            code += `$FaceBookPixel = $_GET['pixel_id'] ? $_GET['pixel_id'] : '';\n`
            code += `$brokerRedirect = true;\n`
            code += `$hasPixel = false;\n`
            code += `?>`

            return code
        },

        copy(selector) {
            const codyText = document.getElementById(selector)
            codyText.select()
            codyText.setSelectionRange(0, 99999)
            document.execCommand("copy")

            this.$vs.notify({
                title: this.$t('global.Copy'),
                text: 'Success',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
            })
        },

        download(text, name, type) {
            const a = document.createElement("a")
            a.classList.add('download_link')
            document.body.appendChild(a)
            a.style = "display: none"

            const blob = new Blob([text], {type}),
                url = window.URL.createObjectURL(blob)
            a.href = url
            a.download = name
            a.click()
            window.URL.revokeObjectURL(url)
            a.remove('download_link')

            this.$vs.notify({
                title: 'Success!',
                text: 'Success',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
            })
        }
    },

    mounted() {
        this.$store.commit('UPDATE_LOADER_STATE', false)
    }
}
</script>
